import { PublicationLayoutProps } from "../../api/publications"
import { Card, Center, Spinner, Image, Grid, GridItem, Heading, Box, Button, Flex, Container, Text, Link as LinkR, useBreakpointValue } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"

import jakob from "../../../public/assets/images/jakobmarkt-inserat.jpg"


const LayoutGallery = ({
    publications,
    isPending,
    title,
    category_img_path,
    handleLoadMore,
    isLoadingMore,
    showMore
}: PublicationLayoutProps) => {
    const [first, ...rest] = publications ?? []
    const isMobile = useBreakpointValue({ base: true, md: false })

    return (
        <>
            {isPending ? (
                <Center
                    position="fixed"
                    top="0"
                    left="0"
                    width="100vw"
                    height="100vh"
                    zIndex="10000"
                    pointerEvents="none"
                >
                    <Spinner size="lg" color="main" />
                </Center>
            ) : (
                <>
                    <Heading size="4xl" color="main" mb={5}>{title}</Heading>
                    {category_img_path &&
                        <Box
                            h="7em"
                            bgColor="mainOpacity"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Image src={category_img_path.replace(/-(LG)\./, "-MD.")} alt="Category image" h="80%" />
                        </Box>
                    }

                    {publications?.length != 0 ? (
                        <>
                        {first &&
                            <Link to="/$slug" params={{ slug: first.classic_id }}>
                                <Card.Root w="100%" my={10} data-testid="publication_card">
                                    <Card.Header pos="relative" p={0}>
                                        {first.lead_image ? (
                                            <Image
                                                src={isMobile ? first.lead_image.path.replace(/-(LG)\./, "-MD.") : first.lead_image.path}
                                                alt={first.lead_image.file_name}
                                                borderTopRadius="md"
                                                maxH="25em"
                                                objectFit="cover"
                                                objectPosition={`${first.lead_image.focal_point ? first.lead_image.focal_point[0] : 50}% ${first.lead_image.focal_point ? first.lead_image.focal_point[1] : 50}%`}
                                            />
                                        ) : (
                                            <Box borderTopRadius="md" h="25em" bgColor="main"></Box>
                                        )}
                                    </Card.Header>
                                    <Card.Body
                                        gap="2"
                                        w="full"
                                        h="full"
                                        p={3}
                                    >
                                        <Card.Title color="main" data-testid="publication_card_title">{first.title}</Card.Title>
                                    </Card.Body>
                                </Card.Root>
                            </Link>
                        }

                        {rest &&
                            <Grid
                                my={20}
                                templateColumns={{
                                    base: "repeat(1, 1fr)",
                                    lg: "repeat(2, 1fr)",
                                    xl: "repeat(3, 1fr)",
                                    "2xl": "repeat(3, 1fr)",
                                }}
                                gap="2em"
                                justifyItems="center"
                                justifyContent="center"
                            >
                                {rest.map((publication) => (
                                    <GridItem cursor="pointer" key={publication.id} w="full">
                                        <Link to="/$slug" params={{ slug: publication.classic_id }}>
                                            <Card.Root w="full" h="full" my={10} data-testid="publication_card">
                                                <Card.Header pos="relative" p={0}>
                                                    {publication.lead_image ? (
                                                        <Image
                                                            src={publication.lead_image.path.replace(/-(LG)\./, "-MD.")}
                                                            alt={publication.lead_image.file_name}
                                                            borderTopRadius="md"
                                                            h="15em"
                                                            objectFit="cover"
                                                            objectPosition={`${publication.lead_image.focal_point ? publication.lead_image.focal_point[0] : 50}% ${publication.lead_image.focal_point ? publication.lead_image.focal_point[1] : 50}%`}
                                                        />
                                                    ) : (
                                                        <Box borderTopRadius="md" h="15em" bgColor="main"></Box>
                                                    )}
                                                </Card.Header>
                                                <Card.Body
                                                    gap="2"
                                                    w="full"
                                                    h="full"
                                                    p={3}
                                                    justifyContent="space-between"
                                                >
                                                    <Card.Title color="main" data-testid="publication_card_title">{publication.title}</Card.Title>
                                                </Card.Body>
                                            </Card.Root>
                                        </Link>
                                    </GridItem>
                                ))}
                            </Grid>
                        }

                        {showMore && (
                            <Flex justifyContent="center">
                                <Button
                                    onClick={handleLoadMore}
                                    variant="secondary"
                                    textTransform="uppercase"
                                    mt="10"
                                    w="12em"
                                >
                                    {isLoadingMore ? <Spinner size="sm" /> : "Mehr Beiträge laden"}
                                </Button>
                            </Flex>
                        )}
                        </>
                    ) : (
                        <Container
                            h="30em"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            textAlign="center"
                        >
                            <Text
                                fontSize="3xl"
                                color="main"
                                fontWeight="bold"
                                mb={4}
                            >
                                Hier gibt es noch keine Beiträge
                            </Text>
                        </Container>
                    )}
                </>
            )}

            <Flex direction="column" alignItems="center" hideFrom="md" my={32} gap={32}>
                <LinkR href="https://www.jakob-markt.ch/jakob-schuehparadies.html" target="_blank" w="100%" cursor="pointer"><Image src={jakob} alt="Jakob's Schuehparadies" /></LinkR>
            </Flex>
        </>
    )
}

export default LayoutGallery
